<div class="day" [class.selected]="selected" [class.disabled]="disabled">
  <span>{{ smallText }}</span>
  {{ bigText }}
  <div class="bottom-stripe"></div>
</div>
